const COOKIES = {
    clr: 'clr',
    dclCruiseListingRefactor: 'dclCruiseListingRefactor',
    dfmDeactivate: 'dfmDeactivate',
    dfmShowDory: 'dfmShowDory',
    dfmShowDwarves: 'dfmShowDwarves',
    durationIsLoggedInCookie: 'durationIsLoggedInCookie',
    facetFilter: 'facetFilter',
    isLoggedIn: 'isLoggedIn',
    publicTokenCookieName: 'paPublicTokenExpireTime',
    rememberme: 'rememberme',
    SWID: 'SWID',
    useMockData: 'useMockData',
    myIdToken: 'access_token'
};

const COOKIES_VALUE = {
    clr: 'true',
    dclCruiseListingRefactor: 'true',
    dfmDeactivate: 'true'
};

const CUSTOM_APP_IMG_PLACEHOLDER = 'dcl-apps-productavail-spa/assets/images/img_placeholder_logo.svg';

const DEFAULT_APP_VALUES = {
    affiliations: [],
    currency: 'USD',
    language: 'en',
    pageNumber: 0,
    portOfCall: 'filteredPort',
    region: 'INTL',
    storeId: 'DCL'
};

const ENDPOINTS = {
    affiliations: 'guests/{swid}/affiliations',
    authenticationStatus: '/profile-api//authentication/status/',
    availableProducts: 'available-products',
    availableSailings: 'available-sailings',
    config: 'config/',
    errorPage: 'errorPage',
    filters: 'quick-quote-filter-options',
    healthMonitor: 'health-monitor/',
    marketingOffers: 'marketing-offers',
    whatsIncludedModal: 'whats-included-modal;type=urlFriendly',
    logout: '/travel-agent-logout/'
};

const PAGE_KEY_TEMPLATE = {
    PROVIDE: 'PAGE_KEY_TEMPLATE',
    USE_VALUE: [
        'siteId',
        'site',
        'url',
        'locale'
    ]
};

const PAGE_KEY_URL_ENDPOINT = {
    PROVIDE: 'PAGE_KEY_URL_ENDPOINT',
    USE_VALUE: '/dcl-apps-productavail-spa/page-key/'
};

const SEO_OPTIONS = {
    PROVIDE: 'SEO_OPTIONS',
    USE_TRANSLATE: false,
    SERVER_PATH: '/dcl-apps-productavail-spa/seo'
};

const STATEROOM_TYPE_TITLES = {
    INSIDE: 'Inside',
    OUTSIDE: 'Oceanview',
    VERANDAH: 'Verandah',
    SUITE: 'Concierge'
};

const API_CONSTANTS = {
    AUTHZ_ENDPOINT: 'authz/private',
    BUNDLE_ENDPOINT: '/language-bundles'
};

const TIME = {
    MILLISECONDS: 1000,
    SECONDS: 60
};

const LOCALE = {
    AKAMAI_COOKIE: 'localeCookie_jar_aka',
    DEFAULT_LOCALE: 'en-us'
};

const CRUISE_DETAILS_PAGE_URL = '{origin}{pathname}{sailingId}/{productName}/{sailingName}/{stateroomType}';

const SESSION_MANAGER = 'sessionManagerURL';

const HEADERS = {
    contentType: 'Content-Type',
    myIdToken: 'X-Disney-Internal-MyId-Token',
    authorizarion: 'Authorization',
    agencyId: 'X-Disney-Internal-AgencyId'
};

const TOGGLES = {
    dclCastMigration: 'dclCastMigration',
    dclTACommerce: 'dclTACommerce'
};

const ENVIRONMENTS = {
    production: 'prd'
};

const AFFILIATION_TYPES = {
    CASTAWAY: 'CASTAWAYCLUB'
};

const FILTERED_REQUESTS_TIMEOUT = 'config|en.json|authz|toggles|health-monitor|page-key';

export {
    AFFILIATION_TYPES,
    API_CONSTANTS,
    COOKIES_VALUE,
    COOKIES,
    CRUISE_DETAILS_PAGE_URL,
    CUSTOM_APP_IMG_PLACEHOLDER,
    DEFAULT_APP_VALUES,
    ENDPOINTS,
    ENVIRONMENTS,
    HEADERS,
    LOCALE,
    PAGE_KEY_TEMPLATE,
    PAGE_KEY_URL_ENDPOINT,
    SEO_OPTIONS,
    SESSION_MANAGER,
    STATEROOM_TYPE_TITLES,
    TIME,
    TOGGLES,
    FILTERED_REQUESTS_TIMEOUT
};
